import {
  Collection,
  CollectionAbandonParams,
  CollectionCheckUpdate,
  CollectionCheckUpdateParamsWithId,
  CollectionCheckUpdateParamsWithUniqueId,
  CollectionCreateParams,
  CollectionDisseminateManifestParams,
  CollectionDisseminateParams,
  CollectionGet,
  CollectionGetAncetorsParamsWithId,
  CollectionGetAncetorsParamsWithUniqueId,
  CollectionGetParamsWithId,
  CollectionGetParamsWithUniqueId,
  CollectionReclaimParams,
  CollectionRemoveParams,
  CollectionUpdateParams,
  CollectionWithdrawManifestParams,
  CollectionWithdrawParams
} from '@aipb/gulliver/personal-content/model';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalContentApiService } from '../personal-content-api.service';
import { CollectionApiInterface } from './collection-api.interface';
import { CollectionCoopJoinParams } from './collection-api.params';

@Injectable({
  providedIn: 'root'
})
export class CollectionApiService implements CollectionApiInterface {
  constructor(private api: PersonalContentApiService) {}

  abandon(params: CollectionAbandonParams): Observable<any> {
    return this.api.post('collectionAbandon', params);
  }

  create(params: CollectionCreateParams): Observable<CollectionGet> {
    return this.api.post('collectionCreate', params);
  }

  disseminate(params: CollectionDisseminateParams): Observable<any> {
    return this.api.post('collectionDisseminate', params);
  }

  get(params: CollectionGetParamsWithId | CollectionGetParamsWithUniqueId): Observable<CollectionGet> {
    return this.api.post('collectionGet', params);
  }

  getAncestors(params: CollectionGetAncetorsParamsWithId | CollectionGetAncetorsParamsWithUniqueId): Observable<any> {
    return this.api.post('collectionGetAncestors', params);
  }

  reclaim(params: CollectionReclaimParams): Observable<any> {
    return this.api.post('collectionReclaim', params);
  }

  remove(params: CollectionRemoveParams): Observable<any> {
    return this.api.post('collectionRemove', params, new HttpHeaders(), (data) => data);
  }

  update(params: CollectionUpdateParams): Observable<any> {
    return this.api.post('collectionUpdate', params);
  }

  withdraw(params: CollectionWithdrawParams): Observable<any> {
    return this.api.post('collectionWithdraw', params);
  }

  checkUpdate(
    params: CollectionCheckUpdateParamsWithId | CollectionCheckUpdateParamsWithUniqueId
  ): Observable<CollectionCheckUpdate> {
    return this.api.post('collectionCheckUpdate', params);
  }

  disseminateManifest(params: CollectionDisseminateManifestParams): Observable<any> {
    return this.api.post('collectionDisseminateManifest', params);
  }

  withdrawManifest(params: CollectionWithdrawManifestParams): Observable<any> {
    return this.api.post('collectionWithdrawManifest', params);
  }

  collectionCoopOpen(id: Collection['id']): Observable<CollectionGet> {
    return this.api.post('collectionCoopOpen', {
      id
    });
  }

  collectionCoopClose(id: Collection['id']): Observable<CollectionGet> {
    return this.api.post('collectionCoopClose', {
      id
    });
  }

  collectionCoopStatus(id: Collection['id']): Observable<CollectionGet> {
    return this.api.post('collectionCoopStatus', {
      id
    });
  }

  collectionCoopJoin(params: CollectionCoopJoinParams): Observable<CollectionGet> {
    return this.api.post('collectionCoopJoin', params);
  }

  collectionCoopLeave(id: Collection['id']): Observable<any> {
    return this.api.post('collectionCoopLeave', {
      id
    });
  }

  collectionCoopPassOwnership(id: Collection['id'], newOwnerId: string): Observable<any> {
    return this.api.post('collectionCoopPassOwnership', {
      id,
      newOwnerId
    });
  }

  collectionCoopTerminate(id: Collection['id'], userId: string): Observable<any> {
    return this.api.post('collectionCoopTerminate', {
      id,
      userId
    });
  }

  collectionReclaim(id: Collection['id']): Observable<any> {
    return this.api.post('collectionReclaim', {
      id
    });
  }
}
